<template>
    <div class="nav-inner">
      <ul>
        <li>
          <img src="../../static/img/icon_1.png" alt="">
          <span>{{innerData.name}}</span>
        </li>
        <li>
          <img v-if="innerData" src="../../static/img/icon_2.png" alt="">
          <span>{{innerTitle}}</span>
        </li>
      </ul>
      <!--<el-tabs class="nav-inner-tab" v-model="activeName" @tab-click="handleClick">-->
        <!--<el-tab-pane v-for="(item,index) in innerData.navChildList" :key="index" :label="item.name" :stretch="false" :name="item.toLink"></el-tab-pane>-->
      <!--</el-tabs>-->
      <div class="tab-mine">
        <div v-for="(item,index) in innerData.navChildList" :key="index" @click="handleClick(item.toLink,$event)">{{item.name}}</div>
        <div class="active" :style="styleObject"></div>
      </div>

    </div>
</template>
<script>
    export default {
      props: ['innerData','innerTitle','innerLink'],
      name: "innerNav",
      data(){
          return {
            activeTab: '',
            styleObject:{}
          }
      },
      mounted(){
        var leftX=0;
        var leftX2=0;
        var link=this.$store.state.fromPath.split('/');
        var innerLink='/'+link[3];
        if (link[3]){
          for(let i=0;i<this.innerData.navChildList.length;i++){
            if(this.innerData.navChildList[i].toLink==innerLink){
              this.styleObject={
                width: this.innerTitle.length *.14+'rem',
                transform: 'translateX('+leftX+'rem)'
              }
              break;
            }
            leftX+=this.innerData.navChildList[i].name.length*.14+.15;
          }
          this.activeTab=this.innerLink;
          if (!this.innerData.navChildList)return;
          setTimeout(()=>{
            this.innerData.navChildList.map((item,index)=>{
              if(item.toLink==this.innerLink){
                this.styleObject={
                  width: this.innerTitle.length *.14+'rem',
                  transform: 'translateX('+(leftX2)+'rem)'
                }
                return;
              }
              leftX2+=item.name.length*.14+.15;
            })
          },60)
        }else {
          this.activeTab=this.innerLink;
          if (!this.innerData.navChildList)return;
          setTimeout(()=>{
            this.innerData.navChildList.map((item,index)=>{
              if(item.toLink==this.innerLink){
                this.styleObject={
                  width: this.innerTitle.length *.14+'rem',
                  transform: 'translateX('+leftX+'rem)'
                }
                return;
              }
              leftX+=item.name.length*.14+.15;
            })
          },60)
        }
      },
      methods: {
        handleClick(url) {
          this.$router.push({path:this.innerData.toLink+url})
        }
      }

    }
</script>

<style lang="less">
  .nav-inner{
    height:0.95rem;
    padding-top: .1rem;
    box-sizing: border-box;
    line-height:.85rem;
    width:100%;
    border-bottom:1px solid rgba(204,204,204,1);
    overflow: hidden;
    clear: both;
      ul{
        color: #000;
        width:30%;
        float: left;
        li{
          float: left;
          font-size:.16rem;
          span{
            font-size:.16rem;
          }
          img{
            width:.2rem;
            height:.2rem;
            margin-right: .05rem;
            vertical-align: text-bottom;
          }
        }
        li:nth-child(2){
          margin-left:.05rem;
        }
      }
      .tab-mine{
        position: relative;
        float: right;
          >div{
             float: left;
             margin-left:.15rem;
             cursor: pointer;
             font-size:.14rem;
           }
           .active{
              position: absolute;
              bottom:0;
              height:.02rem;
              width:.6rem;
              background: red;
              transition:transform .6s;
              -webkit-transition: transform .6s; /* Safari */
           }


      }






      .nav-inner-tab{
        width:70%;
        float: right;
        color: #000;
        .el-tabs__nav{
          float: right;
        }
        .el-tabs__item{
          font-size:.16rem;
          padding:0 15px;
        }
        .el-tabs__item:hover,.is-active{
          color: #000;
        }

        .el-tabs__active-bar{
          background-color:#F53A37
        }
        .el-tabs__nav-wrap::after{
          height:0;
        }
      }

  }



</style>



// WEBPACK FOOTER //
// src/components/innerNav.vue